var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHurtsLittleMoreDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_215_1118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 35C28.2843 35 35 28.2843 35 20C35 11.7157 28.2843 5 20 5C11.7157 5 5 11.7157 5 20C5 28.2843 11.7157 35 20 35Z",
    fill: "#EEEB4E",
    stroke: "#EEEB4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 27H23.6667",
    stroke: "#6E6C0E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8999 12.1382C13.6135 10.9889 14.6709 10.7056 16.7295 10.8441",
    stroke: "#6E6C0E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0996 12.1382C26.3861 10.9889 25.3286 10.7056 23.27 10.8441",
    stroke: "#6E6C0E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.375 21.375C15.7557 21.375 16.875 20.2557 16.875 18.875C16.875 17.4943 15.7557 16.375 14.375 16.375C12.9943 16.375 11.875 17.4943 11.875 18.875C11.875 20.2557 12.9943 21.375 14.375 21.375Z",
    fill: "#6E6C0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.625 21.375C27.0057 21.375 28.125 20.2557 28.125 18.875C28.125 17.4943 27.0057 16.375 25.625 16.375C24.2443 16.375 23.125 17.4943 23.125 18.875C23.125 20.2557 24.2443 21.375 25.625 21.375Z",
    fill: "#6E6C0E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_215_1118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHurtsLittleMoreDefault);
export default __webpack_public_path__ + "static/media/hurts-little-more-default.c5fd459abd2715c2f95195096d2184db.svg";
export { ForwardRef as ReactComponent };